<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="ملحوظة">
<p style="padding-top:150px; text-indent:1em !important;"><span dir="rtl">مِن أشهر مقولات عماد الدين الأصفهاني:</span></p>
<p><span dir="rtl">"إنِّي رأيتُ أنَّه لا يكتب إنسانٌ كتابًا في يومه إلا قال في غده: لو غُيِّر هذا لكان أحسن، ولو زِيدَ كذا لكان يُسْتَحسن، ولو قُدِّمَ هذا لكان أفضل، ولو تُرِك هذا لكان أجمل، وهذا مِن أعظَم العِبر، وهو دليلٌ على استيلاء النَّقص على جملة البشر".</span>s</p>
<p><span dir="rtl"><br/>
</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0001.vue?5f00ae19